import { createSelector } from 'reselect'
import { clientConfigStoreStateSelector } from '@src/selectors/app'
import { InsightMeasurementRange } from '@src/screens/Insights/types'

export const insightsRangeThresholdSelector = createSelector(
  clientConfigStoreStateSelector,
  (clientConfig) => clientConfig.insights.statistics as InsightMeasurementRange[],
)
